export default __webpack_public_path__ + "static/media/HGG-fullLogo.60e4e0bd.svg";